var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"signinSheet"},[_c('Info'),_vm._v(" "),_c('Sheet',{attrs:{"sheet-id":1}}),_vm._v(" "),_c('Notice')],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }